import React, { FunctionComponent } from 'react'

interface SemiCircleType {
  radius: number
  stroke: number
  progress: number
  customClass: string
  animated?: boolean
}

const SemiCircle: FunctionComponent<SemiCircleType> = (props) => {
  const diameter = props.radius * 2
  const normalizedRadius = props.radius - props.stroke / 2
  const arcLength = Math.PI * normalizedRadius

  const getValidProgress = (progress: number): number => {
    if (progress >= 0 && progress <= 100) {
      return progress
    }
    return 100
  }

  const strokeDashoffset =
    arcLength - (getValidProgress(props.progress) / 100) * arcLength

  const viewBoxHeight = props.radius + props.stroke / 2
  const startX = props.stroke / 2
  const startY = props.radius
  const endX = diameter - props.stroke / 2
  const endY = props.radius

  const pathD = `M ${startX} ${startY} A ${normalizedRadius} ${normalizedRadius} 0 0 1 ${endX} ${endY}`

  return (
    <svg
      className={props.customClass}
      width={diameter}
      height={viewBoxHeight}
      viewBox={`0 0 ${diameter} ${viewBoxHeight}`}
    >
      <path
        d={pathD}
        fill='none'
        strokeWidth={props.stroke}
        strokeLinecap='round'
        strokeDasharray={`${arcLength}`}
        style={{
          strokeDashoffset: strokeDashoffset,
          transition: props.animated
            ? 'stroke-dashoffset 1.5s ease-out'
            : 'none',
        }}
      />
    </svg>
  )
}

export default SemiCircle
